/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable arrow-body-style */
import React, { useMemo, useRef, useState } from 'react';
import { last, upperFirst } from 'lodash-es';
import QAInput from '../../../components/QAInput';
import useEditHooks from './useEditHooks';
import Operation from '@/pages/aigc/components/Operation';
import copyIcon from '@/pages/aigc/assets/svg/copy.svg';
import copyActiveIcon from '@/pages/aigc/assets/svg/copy-active.svg';
import editIcon from '@/pages/aigc/assets/svg/edit.svg';
import editActiveIcon from '@/pages/aigc/assets/svg/edit-active.svg';
import { useIntl, useLocation } from 'umi';
import './index.scss';
import CommonBubble from '@home/components/CommonBubble';
import FileList from '../FileList';
import classNames from 'classnames';
import useChatShareHooks from '@/pages/aigc/pages/Agent/ChatShare/useChatShareHooks';
import { CopyStatus } from '@/pages/aigc/pages/Agent/ChatShare/types/chatShare';
import { useSessionId } from '../../hooks/useAgentModalSata';
import { useLocalState } from '../../hooks/useLocalState';
import FieldRefTag from './FieldRefTag';
import InlineMentionText from './InlineMentionText';
import { resolveQuestionDisplayQuery } from '../../../components/QAInput/utils/inlineMentionLabel';
import { LANGUAGE_EN } from '@home/_config/config';

// 单轮QA组件
const EditQuestion = (props: any) => {
  const {
    question,
    userInfo,
    setEditObj,
    editObj,
    messageId,
    handleSubmit,
    isProcessing,
    conversations,
    fileList,
    setHaveEdit,
    isLastQA,
    voiceActiveBar,
    style,
    customQuestion = false,
    custVoiceStyle,
    from: fromType,
    frontend_metadata,
  } = props;

  // TODO: 待重构, 统一用外部传入的userName进行展示
  const userName = upperFirst(userInfo?.username).charAt(0);
  const {
    // isEdit,
    setIsEdit,
    inputValue,
    handelEdit,
    handleCopy,
    isShowEditInput,
    editSessionKey,
    editHydrateEpoch,
    handleEditConfirm,
    editSkills,
    setEditSkills,
    editKnowledge,
    setEditKnowledge,
  } = useEditHooks({
    question,
    userInfo,
    setEditObj,
    editObj,
    messageId,
    conversations,
    handleSubmit,
    fileList,
    setHaveEdit,
    frontend_metadata,
  });
  const { formatMessage, locale } = useIntl();
  const kbDocUnit = formatMessage({ id: 'dba_kb_inline_doc_unit' });
  const { sessionId } = useSessionId();
  const [isHoverCopy, setIsHoverCopy] = useState(false);
  const [isHoverEdit, setIsHoverEdit] = useState(false);
  const [showCopySucceedBubble, setShowCopySucceedBubble] = useState(false);

  const location = useLocation();
  const { getCopyStatusMessage } = useChatShareHooks();
  // 是否是ds报告会话，不需要展示推荐问题
  const [isDSReportSession] = useLocalState('__dba_is_ds_report_session__', false);
  const copySuccessTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isOnCopilot = !location.pathname.includes('/agent/chat');
  const from = fromType === 'copilot' ? 'copilot' : 'agent';
  const operationList = useMemo(() => {
    const list = [
      {
        icon: isHoverCopy ? copyActiveIcon : copyIcon,
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick: () => {
          handleCopy(isOnCopilot).then((copyState) => {
            if(isOnCopilot && copyState) {
              setShowCopySucceedBubble(true);

              if (copySuccessTimeoutRef.current) {
                clearTimeout(copySuccessTimeoutRef.current);
              }
      
              copySuccessTimeoutRef.current = setTimeout(() => {
                setShowCopySucceedBubble(false);
                copySuccessTimeoutRef.current = null;
              }, 2000);
            }
          });
        },
        onMouseEnter: () => {
          setIsHoverCopy(true);
          // console.log('is-hover-copy');
        },
        onMouseLeave: () => {
          setIsHoverCopy(false);
        },
        bubble: showCopySucceedBubble ? 
          getCopyStatusMessage(CopyStatus.DONE) : 
          formatMessage({ id: 'dba_common_copy' }),
        isHidden: true,
        bubbleProps: {
          visible: isHoverCopy || showCopySucceedBubble,
          className: 'dba-copy-bubble'
        }
      },
      {
        icon: isHoverEdit ? editActiveIcon : editIcon,
        onClick: handelEdit,
        onMouseEnter: () => {
          setIsHoverEdit(true);
        },
        onMouseLeave: () => {
          setIsHoverEdit(false);
        },
        bubble: formatMessage({ id: 'dba_common_edit' }),
        isHidden: !isProcessing
      },
    ];
    return list?.filter(item => isLastQA !== null && item.isHidden);
  }, [locale, isHoverCopy, showCopySucceedBubble, isOnCopilot, isHoverEdit, isProcessing, isLastQA]);

  const operationBubbleContent = (
    <div className="dba-edit-copy-box">
      <Operation
        className="dba-copy-edit-question-icon-list"
        operationList={operationList}
      />
    </div>
  );

  const currentConversation = isShowEditInput && conversations?.find(item => item?.messageId === messageId);
  const isEN = locale === LANGUAGE_EN;
  /** 历史展示：display_query 优先；旧 Skill 数据合成 `/名` 内联串（不再单独渲染 tag） */
  const displayQuestion = resolveQuestionDisplayQuery({
    question,
    displayQuery: frontend_metadata?.display_query as string | undefined,
    queryTabs: frontend_metadata?.queryTabs,
    isSkillInherited: frontend_metadata?.isSkillInherited,
    isEN,
    kbExpandToken: frontend_metadata?.kb_expand_token,
  });
  const messageFiles = fileList?.[messageId] || [];
  const hasQuestionFiles = messageFiles.some(
    (item: any) => item?.file?.mimeType !== 'chart' && !item?.external,
  );
  const hasFieldRefTag = Boolean(
    frontend_metadata?.field_name
    || frontend_metadata?.type === 'magic_poster'
    || frontend_metadata?.type === 'custom_dashboard',
  );

  const renderQuestionText = (): React.ReactNode => {
    if (customQuestion) {
      return (
        <div className="dba-message-text">
          <div className="dba-message-text__content">
            {formatMessage({ id: 'dba_common_custom_q' })}
          </div>
        </div>
      );
    }
    if (!displayQuestion) {
      return null;
    }
    return (
      <div className="dba-message-text">
        <div className="dba-message-text__content">
          <InlineMentionText text={displayQuestion} kbDocUnit={kbDocUnit} />
        </div>
      </div>
    );
  };

  return (
    <div  className={classNames('dba-signle-qa-question-content', { "dba-chat-question-only-img": !question})}>
      {isShowEditInput ? (
        <QAInput
          key={`edit-${messageId}-${editSessionKey}`}
          className="dba-chat-input-edit"
          value={inputValue}
          isEdit={true}
          editSessionKey={editSessionKey}
          editHydrateEpoch={editHydrateEpoch}
          fileList={(fileList?.[messageId] || []).filter((f: any) => !f?.external)}
          handleCancelEdit={() => {
            setIsEdit(false);
            setIsHoverEdit(false);
          }}
          isShowDownload={!isDSReportSession}
          onSubmit={handleEditConfirm}
          isProcessing={isProcessing}
          canChangeMode={false}
          voiceActiveBar={voiceActiveBar}
          style={style}
          from={from}
          sessionId={sessionId}
          lastMessages={last(conversations)}
          custVoiceStyle={custVoiceStyle}
          currentConversation={currentConversation}
          selectedSkills={editSkills}
          onSelectedSkillsChange={setEditSkills}
          selectedKnowledge={editKnowledge}
          onSelectedKnowledgeChange={setEditKnowledge}
        />
      ) : (
        <div className={classNames('dba-chat-question-box', { 'dba-chat-question-box--copilot': isOnCopilot })}>
          <div className="dba-chat-question">
            {userName && <div className="dba-head">{userName}</div>}
            <div className="dba-chat-question-column">
              <CommonBubble
                className="dba-chat-question-bubble"
                placement="bottom-end"
                placementOffset={[10, 4]}
                overlayClassName="dba-question-operation-bubble dba-nav-menu-overlay"
                content={operationBubbleContent}
                closeOnScroll
                updateOnDimensionChange={false}
              >
                <div className="dba-chat-question-body">
                  {hasQuestionFiles && (
                    <div className="dba-chat-question-files-wrap">
                      <FileList dataList={messageFiles} />
                    </div>
                  )}
                  {hasFieldRefTag && (
                    <FieldRefTag frontend_metadata={frontend_metadata} />
                  )}
                  <div className="dba-question-img-text">{renderQuestionText()}</div>
                </div>
              </CommonBubble>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditQuestion;
